import script from "./RegistPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegistPage.vue?vue&type=script&lang=ts&setup=true"

import "./RegistPage.vue?vue&type=style&index=0&id=6cf0c3ac&lang=css"

const __exports__ = script;

export default __exports__